// @flow

import Image from './Image';

export default class ContentDeliveryNetwork {
  #url: string;
  #placeholderImage: Image;

  /**
   * Create a new CDN instance
   */
  constructor(cdnUrl: string) {
    this.#url = cdnUrl;
  }

  /**
   * Retrieve a CDN image from the CDN
   */
  image(src: ?string, alt: ?string): Image {
    if (!src) {
      return this.placeholderImage;
    }

    return new Image(this.#url + src, alt || '');
  }

  /**
   * Retrieve a CDN image from the CDN, specifically in the Storefront directory
   */
  storefrontImage(src: ?string, alt: ?string): Image {
    return this.image(`/storefront/${src}`, alt);
  }

  /**
   * Retrieve the cdn url of the CDN
   */
  get url(): string {
    return this.#url;
  }

  /**
   * Retrieve a Placeholder image from the CDN
   */
  get placeholderImage(): Image {
    return this.#placeholderImage;
  }

  /**
   * Set the placeholder image
   */
  set placeholderImage({ src, alt }: { src: string, alt: string }): void {
    this.#placeholderImage = new Image(src, alt);
  }
}
